import { render, staticRenderFns } from "./ReferralLetterTemplate.vue?vue&type=template&id=64e55938&scoped=true"
import script from "./ReferralLetterTemplate.vue?vue&type=script&lang=js"
export * from "./ReferralLetterTemplate.vue?vue&type=script&lang=js"
import style0 from "./ReferralLetterTemplate.vue?vue&type=style&index=0&id=64e55938&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e55938",
  null
  
)

export default component.exports